import { cn } from '@lib/utils/helpers'
import styles from '../styles/iosActivityIndicator.module.css'

type IosActivityIndicatorProps = {
  size?: 'sm' | 'md'
  className?: string
  'data-testid'?: string
  /** Accessible label for screen readers */
  label?: string
}

/** Compact 8-blade spinner modeled after iOS UIActivityIndicatorView. */
export function IosActivityIndicator({
  size = 'sm',
  className,
  'data-testid': dataTestId = 'ios-activity-indicator',
  label = 'Loading',
}: IosActivityIndicatorProps) {
  return (
    <span
      data-testid={dataTestId}
      className={cn(
        styles.spinner,
        size === 'md' && styles.spinnerMd,
        className,
      )}
      role="status"
      aria-label={label}
    >
      {Array.from({ length: 8 }, (_, i) => (
        <span key={i} className={styles.blade} aria-hidden />
      ))}
      <span className="sr-only">{label}</span>
    </span>
  )
}

type IosLoadingOverlayProps = {
  label?: string
  className?: string
  'data-testid'?: string
}

/** Centers a bare spinner over content — no card, pill, or label chrome. */
export function IosLoadingOverlay({
  label = 'Signing in…',
  className,
  'data-testid': dataTestId = 'ios-loading-overlay',
}: IosLoadingOverlayProps) {
  return (
    <div
      data-testid={dataTestId}
      className={cn(styles.overlay, className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <IosActivityIndicator
        size="md"
        label={label}
        data-testid={`${dataTestId}-spinner`}
      />
    </div>
  )
}
